import React from 'react'
import logo from '../assest/logo1.jpg'
import '../stylings/header.css'
import { Link } from 'react-router-dom'
import newGif from '../assest/newGif.gif'

const Header = () => {
    return (
        <>
            {/* Top info strip */}
            <div className="header-top-strip">
                <div className="strip-inner container">

                    <div className="strip-left">
                        <Link to="https://maps.app.goo.gl/S9eiJ715eFjEyEvp6" target="_blank" className="strip-chip">
                            <span className="strip-chip-icon"><i className="fa-solid fa-location-dot"></i></span>
                            <span className="strip-chip-text">Khasra No. 142, Plot 289, Delhi – 110081</span>
                        </Link>
                        <span className="strip-divider"></span>
                        <Link to="mailto:vjconvent2004@gmail.com" className="strip-chip">
                            <span className="strip-chip-icon"><i className="fa-solid fa-envelope"></i></span>
                            <span className="strip-chip-text">vjconvent2004@gmail.com</span>
                        </Link>
                        <span className="strip-divider strip-divider--hide-md"></span>
                        <span className="strip-chip strip-chip--static strip-chip--hide-md">
                            <span className="strip-chip-icon strip-chip-icon--gold"><i className="fa-solid fa-award"></i></span>
                            <span className="strip-chip-text">CBSE Affiliation&nbsp;<strong>2730922</strong></span>
                        </span>
                    </div>

                    <div className="strip-right">
                        <span className="strip-social-label">Follow Us</span>
                        <Link to="https://www.instagram.com/vjconventschool/" target="_blank" className="social-link social-link--ig" aria-label="Instagram">
                            <i className="fa-brands fa-instagram"></i>
                        </Link>
                        <Link to="https://www.youtube.com/@vjconventschool515" target="_blank" className="social-link social-link--yt" aria-label="YouTube">
                            <i className="fa-brands fa-youtube"></i>
                        </Link>
                        <Link to="https://www.facebook.com/vjconvent/" target="_blank" className="social-link social-link--fb" aria-label="Facebook">
                            <i className="fa-brands fa-facebook-f"></i>
                        </Link>
                        <Link to="https://wa.me/919999740333" target="_blank" className="social-link social-link--wa" aria-label="WhatsApp">
                            <i className="fa-brands fa-whatsapp"></i>
                        </Link>
                    </div>

                </div>
            </div>

            {/* Main header */}
            <div className="headerTop">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 headerContainer">

                            <div className="headerTop_Left">
                                <Link to="/" tabIndex="0">
                                    <img src={logo} alt="Vidya Jain Convent School" />
                                </Link>
                            </div>

                            <div className="headerTop_Right">
                                <div className="ContBox-Container">

                                    <div className="ContBox">
                                        <div className="ContBoxleft">
                                            <i className="fa-solid fa-location-dot"></i>
                                        </div>
                                        <div className="ContBoxRight">
                                            <Link to="https://maps.app.goo.gl/S9eiJ715eFjEyEvp6" target="_blank" tabIndex="0">
                                                <div className="ContBoxHd">Location</div>
                                                <div className="ContBoxContent">Click For Map</div>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="ContBox">
                                        <div className="ContBoxleft">
                                            <i className="fa-solid fa-phone-volume"></i>
                                        </div>
                                        <div className="ContBoxRight">
                                            <Link to="tel:+91-9999740333">
                                                <div className="ContBoxHd">Call Us</div>
                                                <div className="ContBoxContent">9999740333</div>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="ContBox admission-box">
                                        <div className="ContBoxleft admission-icon-wrap">
                                            <i className="fa-solid fa-graduation-cap"></i>
                                            <span className="admission-new-tag">NEW</span>
                                        </div>
                                        <div className="ContBoxRight">
                                            <Link to={'/admission_form.pdf'} target="_blank" tabIndex="1">
                                                <div className="ContBoxHd">Admission</div>
                                                <div className="ContBoxContent">Open 2026-2027</div>
                                            </Link>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header
